export default __webpack_public_path__ + "static/media/close-white.54e3dd7b.svg";